/** Pul bo'limi o'ng tugma menyulari (test: menu.test.ts). Bajarib bo'lmaydigan amal ko'rsatilmaydi. */
import { ArrowDownLeft, ArrowLeftRight, ArrowUpRight, ExternalLink, Pencil, Scale, Trash2, Undo2 } from "lucide-react";
import { compactMenu, SEPARATOR, type MenuEntry } from "@/components/ui/context-menu";
import type { MoneyAccount, Transaction } from "./types";

export interface AccountMenuActions {
  income: () => void;
  expense: () => void;
  transfer: () => void;
  edit: () => void;
  reconcile: () => void;
  delete: () => void;
}

export function accountMenu(
  acc: Pick<MoneyAccount, "is_archived">,
  can: { manage: boolean; directExpense: boolean; transfer: boolean },
  a: AccountMenuActions,
  t: (key: string) => string,
): MenuEntry[] {
  if (acc.is_archived) return [];
  return compactMenu([
    { key: "income", label: t("money.menu.income"), icon: ArrowDownLeft, onSelect: a.income },
    can.directExpense && { key: "expense", label: t("money.menu.expense"), icon: ArrowUpRight, onSelect: a.expense },
    can.transfer && { key: "transfer", label: t("money.menu.transfer"), icon: ArrowLeftRight, onSelect: a.transfer },
    SEPARATOR,
    can.manage && { key: "edit", label: t("money.menu.edit"), icon: Pencil, onSelect: a.edit },
    // Qoldiqni solishtirish (owner): haqiqiy karta/kassa qoldig'i -> farq tuzatish yozuvi (2026-10-18)
    can.manage && { key: "reconcile", label: t("money.menu.reconcile"), icon: Scale, onSelect: a.reconcile },
    // O'chirish (arxiv) -- tasdiq bilan, qoldiq bo'lsa ham (2026-10-18, foydalanuvchi talabi); tarix daftarda qoladi
    can.manage && { key: "delete", label: t("money.menu.delete"), icon: Trash2, danger: true, onSelect: a.delete },
  ]);
}

export interface TxMenuActions {
  /** Bog'langan yozuvga o'tish: xarajat, maosh, bonus, driver */
  open: (path: string) => void;
  edit: () => void;
  void: () => void;
}

/** Bog'langan yozuv manzili (yo'q bo'lsa null) */
export function linkedPath(tx: Pick<Transaction, "expense" | "salary" | "bonus" | "driver_id" | "date">): string | null {
  const period = tx.date.slice(0, 7);
  if (tx.expense) return `/budget/expenses?period=${period}`;
  if (tx.salary) return `/budget/salaries?period=${period}`;
  if (tx.bonus) return `/budget/bonuses?period=${period}`;
  if (tx.driver_id) return `/drivers/${tx.driver_id}`;
  return null;
}

export function transactionMenu(tx: Transaction, a: TxMenuActions, t: (key: string) => string): MenuEntry[] {
  if (tx.is_archived) return [];
  const path = linkedPath(tx);
  return compactMenu([
    path !== null && { key: "open", label: t(tx.driver_id ? "money.menu.openDriver" : "money.menu.openLinked"), icon: ExternalLink, onSelect: () => a.open(path) },
    { key: "edit", label: t("money.menu.editMove"), icon: Pencil, onSelect: a.edit },
    SEPARATOR,
    { key: "void", label: t("money.menu.void"), icon: Undo2, danger: true, onSelect: a.void },
  ]);
}
